(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mvf-bookcase-quote"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('mvf-bookcase-configurator')) {
  customElements.define('mvf-bookcase-configurator', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      if (!this.querySelector('[data-labels]')) {requestAnimationFrame(()=>{if(this.isConnected)this.connectedCallback();});return;}
      this.ready = true;
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.max = Math.min(12, Math.max(1, Number(this.dataset.max) || 8));
      this.key = 'mvf-bookcase:' + this.dataset.product + ':' + this.dataset.section;
      this.modules = [{width:30, depth:11, preset:'30', tiers:4, finish:'natural', edge:'straight'}];
      try {
        if (this.querySelector('[data-posted]')) sessionStorage.removeItem(this.key);
        else {
          const saved = JSON.parse(sessionStorage.getItem(this.key));
          if(Array.isArray(saved)) saved.forEach(m=>{if(m && m.depth===undefined)m.depth=11;});
          if (Array.isArray(saved) && saved.length && saved.length <= this.max && saved.every(m => this.validModule(m))) this.modules = saved;
        }
      } catch(e) {}
      this.shared={finish:this.modules[0].finish,depth:this.modules[0].depth,edge:this.modules[0].edge};
      this.modules.forEach(m=>Object.assign(m,this.shared));
      this.querySelectorAll('[data-shared]').forEach(input=>{input.value=this.shared[input.dataset.shared];input.addEventListener('change',event=>this.changeShared(event));if(input.type==='number')input.addEventListener('input',event=>this.changeShared(event));});
      this.querySelector('[data-next]').addEventListener('click',()=>{if(this.check())this.showContact(true);});
      this.querySelector('[data-back]').addEventListener('click',()=>this.showContact(false));
      this.querySelector('[data-controls]').hidden = false;
      this.querySelector('[data-submit]').disabled = false;
      this.querySelector('[data-add]').addEventListener('click', () => {
        if (this.modules.length >= this.max || !this.check()) return;
        this.modules.push({width:30,preset:'30',tiers:4,...this.shared});
        this.renderCards(this.modules.length-1);
      });
      this.querySelector('[data-cards]').addEventListener('change', event => this.change(event));
      this.querySelector('[data-cards]').addEventListener('input', event => {
        if(['width','depth'].includes(event.target.dataset.field)) this.change(event);
      });
      this.querySelector('[data-cards]').addEventListener('click', event => this.action(event));
      this.querySelector('[data-download]').addEventListener('click', () => this.download());
      this.querySelector('form').addEventListener('submit', event => {
        if (!this.check()) {event.preventDefault();return;}
        this.writeSummary();
        if (this.dataset.demo === 'true') {
          event.preventDefault();
          this.querySelector('[data-demo-status]').textContent = this.labels.demo;
        }
      });
      this.renderCards();
      this.showContact(Boolean(this.querySelector('[data-posted], .mvf-bc__notice[role="alert"]')));
    }
    showContact(show){
      this.querySelector('[data-controls]').hidden=show;
      this.querySelector('.mvf-bc__shared').hidden=show;
      this.querySelector('[data-next]').hidden=show;
      const contact=this.querySelector('[data-contact]');contact.hidden=!show;contact.disabled=!show;
      this.querySelector('[data-step-layout]').classList.toggle('mvf-bc__step-active',!show);
      this.querySelector('[data-step-contact]').classList.toggle('mvf-bc__step-active',show);
      if(show){this.writeSummary();contact.querySelector('input:not([type=hidden])')?.focus();}
    }
    changeShared(event){
      const input=event.target;if(!input.checkValidity()||input.value==='')return;
      this.shared[input.dataset.shared]=input.dataset.shared==='depth'?Number(input.value):input.value;
      this.modules.forEach(m=>Object.assign(m,this.shared));this.update();
    }
    validModule(m) {
      return m && Number.isFinite(m.width) && m.width>=24 && m.width<=72 && Number.isFinite(m.depth) && m.depth>=11 && m.depth<=20 && Number.isInteger(m.tiers) && m.tiers>=2 && m.tiers<=7 && ['natural','golden','chestnut'].includes(m.finish) && ['straight','rounded'].includes(m.edge) && ['24','30','38','48','custom'].includes(m.preset) && (m.preset==='custom' || m.width===Number(m.preset));
    }
    check() {return Array.from(this.querySelectorAll('[data-cards] input:not(:disabled), [data-shared]:not(:disabled)')).every(input=>input.reportValidity());}
    renderCards(focus) {
      const container=this.querySelector('[data-cards]');
      const markup=this.querySelector('[data-card-template]').innerHTML;
      container.innerHTML=this.modules.map((m,i)=>markup.replaceAll('__INDEX__',String(i)).replaceAll('__NUMBER__',String(i+1))).join('');
      container.querySelectorAll('[data-index]').forEach((card,i)=>{
        const m=this.modules[i];
        ['preset','tiers','width'].forEach(f=>{card.querySelector('[data-field="'+f+'"]').value=m[f];});
        const custom=m.preset==='custom';
        card.querySelector('[data-custom]').hidden=!custom;
        card.querySelector('[data-field="width"]').disabled=!custom;
        card.querySelector('[data-field="width"]').required=custom;
        card.querySelector('[data-module-height]').textContent=this.format(this.height(m))+' '+this.labels.inches;
        card.querySelector('[data-action="left"]').disabled=i===0;
        card.querySelector('[data-action="right"]').disabled=i===this.modules.length-1;
        card.querySelector('[data-action="remove"]').disabled=this.modules.length===1;
        card.querySelector('[data-action="duplicate"]').disabled=this.modules.length>=this.max;
      });
      this.querySelector('[data-add]').disabled=this.modules.length>=this.max;
      this.querySelector('[data-limit]').hidden=this.modules.length<this.max;
      this.update();
      if (focus!==undefined) container.querySelector('[data-index="'+focus+'"] select')?.focus();
    }
    change(event) {
      const input=event.target,field=input.dataset.field,card=input.closest('[data-index]');
      if (!field || !card) return;
      const m=this.modules[Number(card.dataset.index)];
      if(field==='preset') {
        m.preset=input.value;
        if(input.value!=='custom')m.width=Number(input.value);
        const width=card.querySelector('[data-field="width"]');
        card.querySelector('[data-custom]').hidden=input.value!=='custom';
        width.disabled=input.value!=='custom';width.required=input.value==='custom';width.value=m.width;
        if(input.value==='custom') width.focus();
      } else if(['width','depth'].includes(field)) {
        if (!input.validity.valid || input.value==='') {
          this.querySelector('[data-total]').textContent=this.labels.invalid;
          return;
        }
        m[field]=Number(input.value);
      } else m[field]=field==='tiers'?Number(input.value):input.value;
      card.querySelector('[data-module-height]').textContent=this.format(this.height(m))+' '+this.labels.inches;
      this.update();
    }
    action(event) {
      const button=event.target.closest('[data-action]');
      if(!button || button.disabled) return;
      if(!this.check())return;
      const i=Number(button.closest('[data-index]').dataset.index),a=button.dataset.action;
      let focus=i;
      if(a==='remove' && this.modules.length>1){this.modules.splice(i,1);focus=Math.min(i,this.modules.length-1);}
      if(a==='duplicate' && this.modules.length<this.max){this.modules.splice(i+1,0,{...this.modules[i]});focus=i+1;}
      if(a==='left' && i>0){[this.modules[i-1],this.modules[i]]=[this.modules[i],this.modules[i-1]];focus=i-1;}
      if(a==='right' && i<this.modules.length-1){[this.modules[i+1],this.modules[i]]=[this.modules[i],this.modules[i+1]];focus=i+1;}
      this.renderCards(focus);
    }
    format(n){return new Intl.NumberFormat(document.documentElement.lang || 'en',{maximumFractionDigits:2}).format(n);}
    height(m){return 18.5+15*(m.tiers-2);}
    total(){return Math.round(this.modules.reduce((s,m)=>s+m.width,0)*100)/100;}
    update(){
      try{sessionStorage.setItem(this.key,JSON.stringify(this.modules));}catch(e){}
      this.querySelector('[data-total]').textContent=this.format(this.total())+' '+this.labels.inches;
      this.querySelector('[data-tallest]').textContent=this.format(Math.max(...this.modules.map(m=>this.height(m))))+' '+this.labels.inches;
      this.draw();this.writeSummary();
    }
    summary(){
      return [this.labels.summary_title,this.dataset.productTitle,...this.modules.map((m,i)=>this.labels.module+' '+(i+1)+': '+this.format(m.width)+' '+this.labels.inches+' W × '+this.format(m.depth)+' D × '+this.format(this.height(m))+' H '+this.labels.inches+' / '+m.tiers+' '+this.labels.tier_short+' / '+this.labels[m.finish]+' / '+this.labels[m.edge]),this.labels.summary_width+': '+this.format(this.total())+' '+this.labels.inches,this.labels.width_note,this.labels.schematic,this.labels.summary_notes+': '+this.querySelector('[data-notes]').value].join('\n');
    }
    writeSummary(){
      this.querySelector('[data-body]').value=this.summary();
      this.querySelector('[data-json]').value=JSON.stringify({version:3,shared_options:this.shared,product:this.dataset.product,modules:this.modules.map(m=>({width_inches:m.width,depth_inches:m.depth,height_inches:this.height(m),height_is_inferred:m.tiers===6,tiers:m.tiers,finish:this.labels[m.finish],edge:this.labels[m.edge]})),sum_width_inches:this.total(),spacing:'fixed',dimensions_require_confirmation:true});
    }
    download(){
      if(!this.check())return;
      const url=URL.createObjectURL(new Blob([this.summary()],{type:'text/plain;charset=utf-8'}));
      const a=document.createElement('a');a.href=url;a.download='oak-module-layout.txt';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
    }
    draw(){
      const ns='http://www.w3.org/2000/svg';
      const svg=document.createElementNS(ns,'svg');
      const gap=12,scale=3.2,total=this.modules.reduce((s,m)=>s+m.width*scale,0)+gap*(this.modules.length-1),height=420;
      svg.style.minWidth=Math.max(300,total+50)+'px';
      svg.setAttribute('viewBox','0 0 '+(total+40)+' '+height);svg.setAttribute('role','img');
      const title=document.createElementNS(ns,'title');title.textContent=this.labels.preview+': '+this.modules.map((m,i)=>this.labels.module+' '+(i+1)+', '+m.width+' '+this.labels.inches+', '+m.tiers+' '+this.labels.tier_short).join('; ');svg.append(title);
      const shape=(tag,attrs)=>{const el=document.createElementNS(ns,tag);for(const[k,v]of Object.entries(attrs))el.setAttribute(k,String(v));svg.append(el);return el;};
      const colors={natural:'#bc9259',golden:'#ad762d',chestnut:'#715039'};
      shape('line',{x1:12,x2:total+28,y1:340,y2:340,stroke:'#c6c5bb','stroke-width':2});
      let x=20;
      this.modules.forEach((m,i)=>{
        const w=m.width*scale,h=this.height(m)*scale,y=340-h;
        [x+12,x+w-18].forEach(px=>shape('rect',{x:px,y:y+scale,width:5,height:h-scale,rx:2,fill:'#535859'}));
        for(let tier=0;tier<m.tiers;tier++){
          const sy=340-(3.5+tier*15)*scale;
          shape('rect',{x,y:sy,width:w,height:scale,rx:m.edge==='rounded'?1.6:0.3,fill:colors[m.finish],stroke:'#694f30','stroke-width':.7});
          shape('line',{x1:x+5,x2:x+w-5,y1:sy+1.5,y2:sy+1.5,stroke:'#e8c693','stroke-opacity':.5});
        }
        shape('text',{x:x+w/2,y:y-15,'text-anchor':'middle','font-size':12}).textContent=this.labels.module+' '+(i+1);
        shape('text',{x:x+w/2,y:360,'text-anchor':'middle','font-size':11}).textContent=this.format(m.width)+' '+this.labels.inches+' W · '+m.tiers+' '+this.labels.tier_short;
        shape('text',{x:x+w/2,y:377,'text-anchor':'middle','font-size':11}).textContent=this.format(m.depth)+' '+this.labels.inches+' D';
        shape('text',{x:x+w/2,y:394,'text-anchor':'middle','font-size':11}).textContent=this.format(this.height(m))+' '+this.labels.inches+' H';
        x+=w+gap;
      });
      this.querySelector('[data-drawing]').replaceChildren(svg);
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
